import { inject }              from '@angular/core';
import { ResolveFn }           from '@angular/router';
import { Observable }          from 'rxjs';
import { ListItem }            from '../../../../api/ListItem';
import { TaxDocumentsService } from '../../../../api/tax-documents/tax-documents.service';

export const taxDocumentCustomersResolver: ResolveFn<ListItem<number>[]> = (): Observable<ListItem<number>[]> => {
  return inject(TaxDocumentsService).getTaxDocumentCustomers();
};
